import { _, Backbone, Obscura } from "../../vendor";

import InboomaBaseAsyncCollection from "./InboomaBaseAsyncCollection";
import Pricetype from "../models/Pricetype";

export default InboomaBaseAsyncCollection.extend({
  collectionName: "pricetypes",
  model: Pricetype,
  url: "/pricetypes",

  _pagination: {
    // Updated after each request (response.pagination)
    current_page: 0,
    sort: "name",
    sortDirection: "asc",
    has_next_page: false,
    has_prev_page: false,
    count: 0, // not relevant; response total entities count
    limit: 50,
  },
});
